import { Badge, IBadgeProps } from './Badge';
export { Badge };
export type { IBadgeProps };
export default Badge;
